import * as React from 'react';
import { SVGProps } from 'react';

const IconYandexDzenSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 7.877c2.468-.028 3.849-.19 4.768-1.109.92-.92 1.081-2.3 1.11-4.768A6 6 0 0 0 2 7.877ZM8.236 2.003c.028 2.466.19 3.846 1.109 4.765.905.905 2.257 1.076 4.653 1.108a6 6 0 0 0-5.762-5.873ZM13.994 8.237c-2.393.032-3.745.203-4.65 1.108-.904.904-1.075 2.256-1.107 4.65a6 6 0 0 0 5.757-5.758ZM7.876 13.998c-.032-2.396-.203-3.748-1.108-4.653-.919-.92-2.299-1.08-4.765-1.11a6 6 0 0 0 5.873 5.763Z" />
  </svg>
);
export default IconYandexDzenSizeS;
